module.exports = __webpack_public_path__ + "static/media/p3.59bd4520.PNG";